import {
  enforceEmailVerification,
  markGuardsSettled,
  primeFirstExperienceValue
} from '~/utils/emailVerification'

/**
 * PLATFORM-184: global route guard that sends an unverified user to the
 * console User Information page when the enforce_email_verification PostHog
 * flag is on. It runs LAST in the chain: TOS, migration, MFA and the other
 * forced redirects take priority and mark themselves, so this one never
 * overrides or races them. Runs on every navigation, so a direct URL, the back
 * button or a nav click cannot bypass it. The login page has no user, so it
 * is never gated.
 *
 * @param {object} ctx - Nuxt middleware context.
 * @param {object} ctx.$auth - auth-next instance.
 * @param {object} ctx.$posthog - posthog-js instance.
 * @param {object} ctx.app - Nuxt app (carries $cookies, injected by
 * cookie-universal-nuxt).
 */
export default function emailVerificationRequired(ctx) {
  const { $auth, route } = ctx

  if (!$auth || !$auth.loggedIn || (route && route.path === '/login')) {
    return
  }

  // Every earlier guard has run; flag callbacks arriving from now on may act.
  markGuardsSettled()

  const { $posthog, app } = ctx
  const $cookies = app && app.$cookies

  // Hash the first_experience marker now, so it is ready when the flag lands.
  primeFirstExperienceValue({ $auth, $cookies })

  if (enforceEmailVerification({ $auth, $posthog, $cookies })) {
    // Halt the middleware chain: block the protected render. Same
    // never-resolving-promise idiom mfaRequired uses after its redirect.
    return new Promise(() => {})
  }
}
